export const joursSemaine = [
  { label: "Lundi", value: "LUNDI" },
  { label: "Mardi", value: "MARDI" },
  { label: "Mercredi", value: "MERCREDI" },
  { label: "Jeudi", value: "JEUDI" },
  { label: "Vendredi", value: "VENDREDI" },
  { label: "Samedi", value: "SAMEDI" },
  { label: "Dimanche", value: "DIMANCHE" },
];
